var _path, _path2, _path3, _path4, _path5, _path6, _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 182,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.783 95.25a.726.726 0 0 0 0-1.034.719.719 0 0 0-1.027 0l-1.755 1.75-1.765-1.75a.719.719 0 0 0-1.027 0 .746.746 0 0 0 0 1.035L1.963 97 .21 98.75a.746.746 0 0 0 0 1.034.719.719 0 0 0 1.027 0L3 98.034l1.755 1.75a.719.719 0 0 0 1.027 0 .726.726 0 0 0 0-1.035L4.03 97l1.754-1.75Z",
    fill: "#ED7253"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.856.834a.485.485 0 0 0 0-.69.48.48 0 0 0-.685 0l-1.17 1.166-1.177-1.166a.48.48 0 0 0-.685 0 .498.498 0 0 0 0 .69L122.309 2l-1.17 1.166a.498.498 0 0 0 0 .69.48.48 0 0 0 .685 0l1.177-1.166 1.17 1.166a.48.48 0 0 0 .685 0 .485.485 0 0 0 0-.69L123.686 2l1.17-1.166Z",
    fill: "#D35F44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.783 177.251a.726.726 0 0 0 0-1.035.719.719 0 0 0-1.027 0l-1.755 1.749-1.765-1.749a.719.719 0 0 0-1.027 0 .746.746 0 0 0 0 1.035L42.963 179l-1.754 1.749a.746.746 0 0 0 0 1.035.719.719 0 0 0 1.027 0L44 180.035l1.755 1.749a.719.719 0 0 0 1.027 0 .726.726 0 0 0 0-1.035L45.028 179l1.755-1.749ZM216.783 171.251a.726.726 0 0 0 0-1.035.718.718 0 0 0-1.027 0l-1.755 1.749-1.765-1.749a.718.718 0 0 0-1.027 0 .745.745 0 0 0 0 1.035l1.754 1.749-1.754 1.749a.745.745 0 0 0 0 1.035.718.718 0 0 0 1.027 0l1.765-1.749 1.755 1.749a.718.718 0 0 0 1.027 0 .726.726 0 0 0 0-1.035L215.029 173l1.754-1.749Z",
    fill: "#ED7253"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.405 71.606a.936.936 0 0 0 0-1.329.919.919 0 0 0-1.316 0l-2.246 2.247-2.261-2.247a.918.918 0 0 0-1.315 0 .96.96 0 0 0 0 1.33l2.247 2.246-2.247 2.247a.96.96 0 0 0 0 1.329c.37.37.959.37 1.315 0l2.261-2.247 2.246 2.246c.357.37.959.37 1.316 0a.936.936 0 0 0 0-1.328l-2.247-2.247 2.247-2.247Z",
    fill: "#D35F44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.405 23.606a.936.936 0 0 0 0-1.329.919.919 0 0 0-1.316 0l-2.246 2.247-2.261-2.247a.918.918 0 0 0-1.315 0 .96.96 0 0 0 0 1.33l2.247 2.246-2.247 2.247a.96.96 0 0 0 0 1.328c.37.37.959.37 1.315 0l2.261-2.246 2.246 2.247c.357.37.959.37 1.316 0a.936.936 0 0 0 0-1.33l-2.247-2.246 2.247-2.247Z",
    fill: "#ED7253"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.404 44.606a.934.934 0 0 0 0-1.329.918.918 0 0 0-1.315 0l-2.246 2.247-2.26-2.247a.918.918 0 0 0-1.316 0 .96.96 0 0 0 0 1.33l2.247 2.246-2.247 2.247a.96.96 0 0 0 0 1.328c.37.37.96.37 1.315 0l2.26-2.246 2.247 2.246c.357.37.96.37 1.316 0a.934.934 0 0 0 0-1.328l-2.247-2.247 2.246-2.247ZM33.483 138.189a.692.692 0 0 0 0-.984.681.681 0 0 0-.974 0l-1.664 1.664-1.673-1.664a.681.681 0 0 0-.974 0 .71.71 0 0 0 0 .984l1.663 1.664-1.663 1.664a.71.71 0 0 0 0 .983.68.68 0 0 0 .974 0l1.673-1.663 1.664 1.663a.68.68 0 0 0 .974 0 .69.69 0 0 0 0-.983l-1.664-1.664 1.664-1.664ZM243.483 109.189a.692.692 0 0 0 0-.984.682.682 0 0 0-.974 0l-1.664 1.664-1.673-1.664a.682.682 0 0 0-.974 0 .71.71 0 0 0 0 .984l1.663 1.664-1.663 1.664a.709.709 0 0 0 0 .983.68.68 0 0 0 .974 0l1.673-1.663 1.664 1.663a.68.68 0 0 0 .974 0 .69.69 0 0 0 0-.983l-1.664-1.664 1.664-1.664ZM64.483 3.19a.692.692 0 0 0 0-.985.68.68 0 0 0-.974 0L61.845 3.87l-1.673-1.664a.68.68 0 0 0-.974 0 .71.71 0 0 0 0 .984l1.663 1.664-1.663 1.664a.71.71 0 0 0 0 .983.68.68 0 0 0 .974 0l1.673-1.663L63.51 7.5a.68.68 0 0 0 .974 0 .692.692 0 0 0 0-.983l-1.664-1.664 1.664-1.664Z",
    fill: "#D35F44"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 26,
    width: 156,
    height: 156
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 104,
    r: 78,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.232 113.74c10.771 4.105 22.351 5.634 33.855 6.361 57.362 3.629 114.858-12.115 165.941-38.459 37.791-19.49 73.138-44.96 114.136-56.238l10.691-44.119C269.826 8.162 217.174 35.08 162.4 57.107c-23.942 9.629-48.416 18.351-73.843 22.752-25.427 4.4-51.986 4.339-76.611-3.377C6.15 74.666.023 72.046-2.88 66.712l.648 47.028Z",
    fill: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.513 128.946c1.381-11.136 9.607-21.133 20.269-24.633 4.703-1.544 10.166-2.139 13.376-5.906 2.935-3.445 2.979-8.399 4.152-12.77 2.755-10.266 13.086-17.948 23.71-17.668 3.468.091 6.871.933 10.326 1.244 5.651.51 11.324-.403 16.921-1.329 5.808-.96 12.419-2.493 15.154-7.707 3.401-6.484-1.292-14.046-2.582-21.253-1.307-7.308 1.263-15.197 6.624-20.333 4.862-4.658 11.51-6.905 18.024-8.606 10.631-2.778 34.694-15.821 32.518-5.051-.421 2.083 1.777 94.852 1.777 94.852s-145.528 55.397-146.406 54.078c-.879-1.319-13.86-24.918-13.86-24.918h-.003Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.668 164.636c-4.538-3.65-4.99-10.81-2.246-15.947 2.743-5.137 7.927-8.527 13.266-10.855 21.842-9.525 47.834-4.482 69.868-13.551 3.317-1.366 6.613-3.124 8.818-5.954 2.205-2.83 3.074-6.949 1.288-10.061-2.172-3.786-7.07-4.717-11.155-6.254-4.085-1.536-8.35-5.6-6.627-9.608 1.139-2.649 4.298-3.66 7.091-4.372L205.335 59.37c7.897-2.015 15.999-4.122 22.618-8.875 6.62-4.752 11.513-12.823 10.127-20.854-1.113-6.451-5.888-11.562-10.445-16.26-2.75-2.836-5.559-5.715-9.028-7.607-6.467-3.525-14.27-3.155-21.621-2.69-31.464 1.986-62.929 3.971-94.393 5.958 0 0-80.918-1.561-88.393-1.561-7.474 0-14.949 148.166-14.949 148.166l13.416 8.988h.001Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.312 156.592c32.275-22.81 72.856-33.584 112.195-29.79 13.203 1.273 26.286 4.123 39.551 4.123 23.354 0 45.702-8.786 67.393-17.439 19.74-7.875 39.497-15.757 58.651-24.967 12.001-5.77 23.903-12.112 36.868-15.15 24.239-5.682 49.489.694 73.562 7.038l-28.037 158.338-371.077-14.51 10.894-67.643Z",
    fill: "#E68870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.603 94.026a1.014 1.014 0 1 0 0-2.028 1.014 1.014 0 0 0 0 2.028ZM66.603 97.194a1.014 1.014 0 1 0 0-2.028 1.014 1.014 0 0 0 0 2.028ZM66.603 100.362a1.014 1.014 0 1 0-.001-2.028 1.014 1.014 0 0 0 0 2.028Z",
    stroke: "#fff",
    strokeWidth: 0.304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.41 181.779a3.249 3.249 0 0 1 4.596 0 3.247 3.247 0 0 0 4.594 0 3.249 3.249 0 0 1 4.595 0l.04.04a3.249 3.249 0 0 0 4.595 0l.058-.058a3.247 3.247 0 0 1 4.595 0",
    stroke: "#fff",
    strokeWidth: 0.284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.454 149.295c-.681-2.472-1.877-4.903-4.011-6.588-2.629-2.076-6.366-2.796-9.13-4.734-1.552-1.088-2.738-2.519-3.861-3.958a98.09 98.09 0 0 1-6.288-9.056c-1.672-2.725-3.241-5.571-5.739-7.744-6.026-5.246-15.692-5.318-23.636-8.074-11.354-3.939-18.629-22.589-18.629-22.589l-.021.027a33.764 33.764 0 0 0-1.11-3.014c-3.188-7.483-8.24-7.884-8.24-7.884-4.443-4.25-13.392-.802-16.518 1.043-15.21 8.97-9.596 35.657-12.452 42.118-1.611 3.646-7.78 4.612-6.486 8.382.939 2.732 3.566 4.519 6.208 5.684 6.418 2.827 13.658 3.106 20.664 2.77.333-.016.665-.034.997-.053.754 2.798 2.376 5.335 5.014 6.95 1.962 1.199 4.345 1.817 6.287 3.043 2.02 1.273 3.449 3.136 4.595 5.077 3.576 6.051 5.062 13.511 11.188 17.676 5.444 3.701 13.027 3.724 19.74 5.299 2.278.534 4.508 1.264 6.87 1.461 3.284.274 6.598-.498 9.824-1.272 4.743-1.138 9.532-2.313 13.876-4.392 4.343-2.08 8.265-5.179 10.172-9.17 1.666-3.486 1.676-7.408.685-11l.001-.002Z",
    fill: "#ED7253"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.109 147.848s14.661 43.745 33.668 43.745c25.41 0 38.692-61.311 38.692-61.311l-17.56-6.935s-21.432 28.293-21.545 28.025l-5.46-11.203-27.794 7.68-.001-.001Z",
    fill: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m166.449 122.537.356-13.678a1.64 1.64 0 0 1 1.64-1.597h1.457s2.391-18.065 4.649-17.931c2.258.133 0 15.939 0 15.939l2.258-5.362c.362-.86 1.566-.889 1.971-.05l.715 1.659.368-.987a.962.962 0 0 1 1.732.062l1.058 2.42.068-.112a.994.994 0 0 1 1.697-.012c.857 1.368 1.937 3.996 1.69 8.36-.399 7.04-.926 11.314-.926 11.314l-15.811 2.766-2.922-2.789v-.002Z",
    fill: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.526 106.196c0 .399-2.431 7.274-.905 7.842 1.706.633 5.009-9.849 5.009-9.849M182.654 103.013l-1.664 3.957M180.263 108.75s-3.188 6.23-1.583 6.661c1.066.287 5.209-7.716 5.209-7.716s-1.68 2.418-.593 4.617",
    stroke: "#E68870",
    strokeWidth: 0.091,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.762 112.18c-1.789 4.916-2.83 4.128-2.83 4.128s-1.039-.219.765-6.728M170.853 111.12s1.995.924 2.124 4.341c.064 1.678-.365 3.34-1.179 4.809l-.81 1.466M168.941 111.386l4.476-.865M169.902 107.264l4.176.281M178.885 103.528c0-.077.711-2.035.711-2.035",
    stroke: "#E68870",
    strokeWidth: 0.091,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.411 141.524s4.237-12.814 4.948-20.549c.723-7.853-6.123 1.76-6.123 1.76l-6.374.503-6.29-5.369s.335 3.355-1.593 6.795c-1.93 3.439 6.374 7.717 6.29 8.052-.084.335 4.697 8.975 4.697 8.975l4.446-.167h-.001ZM25.936 154.744c1.712-3.294 13.803-20.331 13.803-20.331l23.503 12.748s-16.45 54.404-35.729 45.349c-16.13-7.577-34.625-56.316-34.625-56.316s11.652-13.731 13.168-8.782c2.839 9.259 19.881 27.332 19.881 27.332h-.001Z",
    fill: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m117.067 146.201 21.836-6.033c-12.985-24.348-22.725-25.234-57.06-25.738-32.714-.481-42.104 19.983-42.104 19.983l23.503 12.748s-12.232 29.992-10.125 48.798c.328 2.921 65.569 1.212 65.569 1.212-.009-.042-.038-.225-.087-.532 1.629-.149 6.413-.571 8.412-.571 5.009 0-.604-16.627-.604-16.627l-9.338-33.238-.002-.002Z",
    fill: "#E68870"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.489 115.298s-.557 11.358 8.35 12.262c8.3.842 14.521-3.764 15.479-11.387",
    stroke: "#FFE2DC",
    strokeWidth: 0.142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m88.072 101.698-6.228 12.731s1.023 11.202 8.801 11.202c9.221 0 12.554-10.44 12.554-10.44l.47-10.803-15.597-2.692v.002Z",
    fill: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.622 100.877c2.47 9.595 16.45 3.652 16.45 3.652l5.417 5.23 1.867-.561 1.599-22.706c.189-2.678-.89-5.417-3.143-6.877-16.531-10.713-24.595 11.923-22.19 21.261v.001Z",
    fill: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.861 106.234c2.495 0 4.666-.682 6.698-1.623.17-.08.31.155.158.267-2.778 2.039-8.554 6.272-9.431 6.874-.462.316 2.575-5.517 2.575-5.517v-.001Z",
    fill: "#E68870"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.983 82.197c-.447.41-1.126.406-1.73.357-1.513-.12-3.015-.363-4.532-.413-1.516-.05-3.071.105-4.449.74-2.519 1.159-3.17 3.6-6.266 5.407-.437.256-.833.596-1.322.727-.488.13-1.046.088-1.45-.214l3.017-7.255 3.12-2.987 4.949-2.02 5.596-.883 4.006.883 2.297 2.02-3.234 3.639-.002-.001Z",
    fill: "#ED7253"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.738 79.086a12.234 12.234 0 0 0-2.567 1.898c-.407.394-.805.85-.896 1.41-.139.862.489 1.66 1.18 2.194.692.534 1.502.95 2.004 1.663.573.816.641 1.884.569 2.88-.072.995-.263 1.996-.128 2.986.179 1.312.925 2.495 1.862 3.43.937.936 2.063 1.656 3.179 2.367l2.973 1.897c-.568-3.097-.532-6.267-.732-9.408-.201-3.143-.659-6.343-2.122-9.13l-5.322-2.186v-.001Z",
    fill: "#ED7253"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.946 95.552c.14-1.478 1.141-2.195 2.238-2.887 1.454-.915 2.544-.525 3.122.472.648 1.119-.354 4.064-2.858 5.093-1.302.535-2.602-1.633-2.502-2.678Z",
    fill: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.62,
    fill: "#E68870"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M174.582 93.82a4.005 4.005 0 1 0 .001-8.01 4.005 4.005 0 0 0-.001 8.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M174.583 96.302a6.486 6.486 0 1 0 0-12.973 6.486 6.486 0 0 0 0 12.973Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M174.583 98.26a8.446 8.446 0 1 0 0-16.892 8.446 8.446 0 0 0 0 16.893Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.386 36.15H9.224c-.593 0-1.075.48-1.075 1.074V85.03c0 .594.482 1.075 1.075 1.075h56.162c.593 0 1.075-.481 1.075-1.075V37.224c0-.593-.482-1.075-1.075-1.075Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.386 89.512H9.224c-.593 0-1.075.481-1.075 1.075v25.46c0 .594.482 1.075 1.075 1.075h56.162c.593 0 1.075-.481 1.075-1.075v-25.46c0-.594-.482-1.075-1.075-1.075Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.121 67.169H132.54c-.593 0-1.074.481-1.074 1.075v47.805c0 .594.481 1.075 1.074 1.075h117.581c.594 0 1.075-.481 1.075-1.075V68.244c0-.594-.481-1.075-1.075-1.075Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54 120.53h-56.161c-.594 0-1.075.482-1.075 1.075v64.739c0 .594.481 1.075 1.075 1.075h56.161c.594 0 1.075-.481 1.075-1.075v-64.739c0-.593-.481-1.075-1.075-1.075Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54 36.15h-56.161c-.594 0-1.075.48-1.075 1.074v25.461c0 .594.481 1.075 1.075 1.075h56.161c.594 0 1.075-.481 1.075-1.075v-25.46c0-.594-.481-1.076-1.075-1.076Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.963 137.466H70.802c-.594 0-1.075.481-1.075 1.075v47.805c0 .593.481 1.075 1.075 1.075h56.161c.594 0 1.075-.482 1.075-1.075v-47.805c0-.594-.481-1.075-1.075-1.075Z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.963 67.169H70.802c-.594 0-1.075.481-1.075 1.075v64.739c0 .594.481 1.075 1.075 1.075h56.161c.594 0 1.075-.481 1.075-1.075v-64.74c0-.593-.481-1.074-1.075-1.074Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.963 36.15H70.802c-.594 0-1.075.48-1.075 1.074v25.461c0 .594.481 1.075 1.075 1.075h56.161c.594 0 1.075-.481 1.075-1.075v-25.46c0-.594-.481-1.076-1.075-1.076Z",
    fill: "url(#k)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m115.338 168.036-10.334-17.806c-.424-.689-1.139-1.113-1.934-1.113-.795 0-1.51.424-1.934 1.113l-10.334 17.806a2.225 2.225 0 0 0 0 2.225 2.204 2.204 0 0 0 1.934 1.113h20.721c.794 0 1.536-.424 1.934-1.113a2.166 2.166 0 0 0-.053-2.225Zm-12.268-13.302c.901 0 1.643.769 1.59 1.67l-.318 6.147a1.262 1.262 0 0 1-1.272 1.219c-.689 0-1.245-.53-1.272-1.219l-.318-6.147a1.581 1.581 0 0 1 1.589-1.67h.001Zm0 13.54a1.662 1.662 0 0 1-1.669-1.669c0-.927.741-1.669 1.669-1.669.927 0 1.669.742 1.669 1.669s-.742 1.669-1.669 1.669ZM84.488 52.514v-5.688h3.594v1.184H85.89v1.02h2.077v1.185h-2.077v1.114h2.24v1.185h-3.64ZM89.092 52.514v-5.735h2.357c.742 0 1.325.166 1.75.499.426.327.639.81.639 1.449v.125c0 .41-.091.756-.273 1.036a1.7 1.7 0 0 1-.778.639l1.393 1.987h-1.665l-1.151-1.745h-.825v1.745h-1.447Zm2.443-4.52h-.996v1.66h.996c.254 0 .456-.073.607-.218.155-.15.233-.353.233-.608 0-.254-.078-.457-.233-.608-.15-.15-.353-.225-.607-.225ZM94.85 52.514v-5.735h2.358c.742 0 1.325.166 1.75.499.425.327.638.81.638 1.449v.125c0 .41-.09.756-.272 1.036a1.7 1.7 0 0 1-.778.639l1.392 1.987h-1.664l-1.152-1.745h-.824v1.745H94.85Zm2.444-4.52h-.996v1.66h.995c.255 0 .457-.073.607-.218.156-.15.234-.353.234-.608 0-.254-.078-.457-.234-.608-.15-.15-.352-.225-.607-.225ZM103.334 52.67c-.519 0-.97-.089-1.354-.265a2.894 2.894 0 0 1-.957-.71 3.093 3.093 0 0 1-.568-.958 2.925 2.925 0 0 1-.186-.997v-.172a2.943 2.943 0 0 1 .777-1.994c.26-.28.579-.504.957-.67.384-.167.828-.25 1.331-.25.497 0 .936.083 1.314.25a2.815 2.815 0 0 1 1.548 1.613c.135.342.203.693.203 1.051v.172c0 .322-.065.654-.195.997a3.073 3.073 0 0 1-.568.959c-.254.29-.573.527-.957.709-.383.176-.832.265-1.345.265Zm0-1.356c.332 0 .617-.073.855-.218a1.48 1.48 0 0 0 .553-.592c.129-.25.194-.53.194-.842 0-.332-.065-.62-.194-.865a1.37 1.37 0 0 0-.56-.576 1.646 1.646 0 0 0-.848-.21c-.493 0-.885.152-1.175.459-.285.301-.428.699-.428 1.192 0 .312.065.592.195.842.129.249.313.446.552.592.238.145.524.218.856.218ZM107.272 52.514v-5.735h2.357c.742 0 1.325.166 1.751.499.425.327.637.81.637 1.449v.125c0 .41-.09.756-.272 1.036-.181.28-.441.494-.778.639l1.393 1.987h-1.665l-1.151-1.745h-.825v1.745h-1.447Zm2.443-4.52h-.996v1.66h.996c.254 0 .456-.073.607-.218.155-.15.233-.353.233-.608 0-.254-.078-.457-.233-.608-.151-.15-.353-.225-.607-.225ZM196.546 100.061l-10.334-17.806c-.424-.688-1.139-1.112-1.934-1.112-.795 0-1.51.424-1.934 1.112l-10.334 17.806a2.23 2.23 0 0 0 0 2.226 2.204 2.204 0 0 0 1.934 1.113h20.721c.794 0 1.536-.424 1.934-1.113a2.167 2.167 0 0 0-.053-2.226ZM184.278 86.76c.901 0 1.643.768 1.59 1.67l-.318 6.146a1.262 1.262 0 0 1-1.272 1.22c-.689 0-1.245-.53-1.272-1.22l-.318-6.147a1.58 1.58 0 0 1 1.589-1.67h.001Zm0 13.54a1.663 1.663 0 0 1-1.669-1.67c0-.927.742-1.669 1.669-1.669s1.669.742 1.669 1.67c0 .927-.742 1.669-1.669 1.669ZM175.346 55.106l-5.434-9.465a1.19 1.19 0 0 0-1.017-.591 1.19 1.19 0 0 0-1.017.591l-5.433 9.465a1.194 1.194 0 0 0 0 1.183c.209.366.585.591 1.017.591h10.894c.418 0 .808-.225 1.017-.591a1.164 1.164 0 0 0-.027-1.183Zm-6.451-7.07c.474 0 .864.408.836.887l-.167 3.267a.667.667 0 0 1-.669.648.667.667 0 0 1-.669-.648l-.167-3.267a.836.836 0 0 1 .836-.887Zm0 7.196a.879.879 0 0 1-.878-.887.879.879 0 1 1 1.756 0c0 .493-.39.887-.878.887ZM32.756 106.252v-5.688h3.594v1.184h-2.194v1.021h2.077v1.185h-2.077v1.114h2.24v1.184h-3.64ZM37.36 106.252v-5.735h2.357c.741 0 1.325.166 1.75.499.425.327.638.81.638 1.449v.125c0 .41-.09.756-.272 1.036-.182.281-.441.494-.778.639l1.392 1.987h-1.665l-1.15-1.745h-.826v1.745H37.36Zm2.442-4.519h-.996v1.659h.996c.254 0 .457-.072.607-.218.156-.15.233-.353.233-.607 0-.255-.077-.458-.233-.608-.15-.151-.353-.226-.607-.226ZM43.118 106.252v-5.735h2.357c.742 0 1.325.166 1.75.499.426.327.639.81.639 1.449v.125c0 .41-.091.756-.273 1.036-.181.281-.44.494-.778.639l1.393 1.987H46.54l-1.151-1.745h-.825v1.745h-1.447Zm2.443-4.519h-.996v1.659h.996c.254 0 .456-.072.607-.218.155-.15.233-.353.233-.607 0-.255-.078-.458-.233-.608-.15-.151-.353-.226-.607-.226ZM51.6 106.408c-.518 0-.969-.088-1.353-.265a2.9 2.9 0 0 1-.957-.709 3.088 3.088 0 0 1-.568-.958 2.921 2.921 0 0 1-.186-.998v-.171a2.951 2.951 0 0 1 .778-1.995c.26-.28.578-.504.957-.67.383-.166.827-.249 1.33-.249.498 0 .936.083 1.315.249.383.166.705.39.964.67.26.281.454.595.584.943.135.343.202.693.202 1.052v.171c0 .322-.065.655-.194.998a3.084 3.084 0 0 1-.568.958 2.898 2.898 0 0 1-.957.709c-.384.177-.833.265-1.346.265Zm0-1.356c.333 0 .618-.073.857-.218a1.48 1.48 0 0 0 .552-.592c.13-.25.194-.53.194-.842 0-.332-.064-.62-.194-.865a1.364 1.364 0 0 0-.56-.576 1.646 1.646 0 0 0-.848-.211c-.493 0-.884.154-1.175.46-.285.301-.428.699-.428 1.192 0 .312.065.592.195.842.13.249.314.447.552.592.239.145.524.218.856.218ZM55.54 106.252v-5.735h2.357c.741 0 1.325.166 1.75.499.425.327.638.81.638 1.449v.125c0 .41-.091.756-.272 1.036-.182.281-.441.494-.778.639l1.392 1.987h-1.665l-1.151-1.745h-.825v1.745H55.54Zm2.442-4.519h-.996v1.659h.996c.254 0 .456-.072.607-.218.156-.15.233-.353.233-.607 0-.255-.078-.458-.233-.608-.15-.151-.353-.226-.607-.226ZM150.257 161.078v-9.859h6.335v2.053h-3.867v1.769h3.661v2.053h-3.661v1.932h3.949v2.052h-6.417ZM158.372 161.078v-9.94h4.154c1.308 0 2.336.288 3.086.864.749.568 1.124 1.405 1.124 2.513v.216c0 .711-.16 1.31-.48 1.796-.32.486-.777.855-1.371 1.107l2.454 3.444h-2.934l-2.029-3.025h-1.454v3.025h-2.55Zm4.305-7.833h-1.755v2.877h1.755c.448 0 .805-.126 1.07-.378.274-.262.411-.613.411-1.054 0-.441-.137-.792-.411-1.053-.265-.262-.622-.392-1.07-.392ZM168.522 161.078v-9.94h4.155c1.307 0 2.335.288 3.085.864.749.568 1.124 1.405 1.124 2.513v.216c0 .711-.16 1.31-.48 1.796-.32.486-.777.855-1.371 1.107l2.454 3.444h-2.934l-2.029-3.025h-1.454v3.025h-2.55Zm4.305-7.833h-1.755v2.877h1.755c.448 0 .805-.126 1.07-.378.274-.262.411-.613.411-1.054 0-.441-.137-.792-.411-1.053-.265-.262-.622-.392-1.07-.392ZM183.474 161.349c-.914 0-1.71-.153-2.386-.46a5.086 5.086 0 0 1-1.687-1.229 5.33 5.33 0 0 1-1.001-1.661 4.984 4.984 0 0 1-.329-1.729v-.297c0-.621.114-1.229.343-1.823a4.898 4.898 0 0 1 1.028-1.634 4.993 4.993 0 0 1 1.687-1.162c.676-.288 1.458-.432 2.345-.432.877 0 1.65.144 2.317.432a4.96 4.96 0 0 1 1.7 1.162c.457.486.8 1.031 1.029 1.634a4.88 4.88 0 0 1 .356 1.823v.297a4.79 4.79 0 0 1-.343 1.729 5.311 5.311 0 0 1-1.001 1.661 5.092 5.092 0 0 1-1.686 1.229c-.677.307-1.467.46-2.372.46Zm0-2.35c.585 0 1.087-.127 1.508-.379.42-.252.745-.594.974-1.026a3.08 3.08 0 0 0 .342-1.459c0-.576-.114-1.076-.342-1.499a2.385 2.385 0 0 0-.988-.999c-.42-.244-.918-.365-1.494-.365-.869 0-1.559.266-2.071.797-.503.522-.754 1.211-.754 2.066 0 .54.114 1.027.343 1.459.228.432.553.774.973 1.026.421.252.924.379 1.509.379ZM190.415 161.078v-9.94h4.155c1.307 0 2.336.288 3.085.864.75.568 1.125 1.405 1.125 2.513v.216c0 .711-.16 1.31-.48 1.796-.32.486-.777.855-1.371 1.107l2.454 3.444h-2.934l-2.03-3.025h-1.453v3.025h-2.551Zm4.306-7.833h-1.755v2.877h1.755c.448 0 .804-.126 1.07-.378.274-.262.411-.613.411-1.054 0-.441-.137-.792-.411-1.053-.266-.262-.622-.392-1.07-.392Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 8.149,
    y1: 61.128,
    x2: 66.461,
    y2: 61.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3AD9A",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5160",
    stopOpacity: 0.146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F3AD9A",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AD9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 8.149,
    y1: 103.318,
    x2: 66.461,
    y2: 103.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3AD9A",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5160",
    stopOpacity: 0.146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F3AD9A",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AD9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 131.466,
    y1: 92.148,
    x2: 251.196,
    y2: 92.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3AD9A",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5160",
    stopOpacity: 0.146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F3AD9A",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AD9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 131.304,
    y1: 153.976,
    x2: 189.615,
    y2: 153.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3AD9A",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5160",
    stopOpacity: 0.146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F3AD9A",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AD9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 131.304,
    y1: 49.956,
    x2: 189.615,
    y2: 49.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3AD9A",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5160",
    stopOpacity: 0.146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F3AD9A",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AD9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 69.727,
    y1: 162.445,
    x2: 128.038,
    y2: 162.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3AD9A",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5160",
    stopOpacity: 0.146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F3AD9A",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AD9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 69.727,
    y1: 100.615,
    x2: 128.038,
    y2: 100.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3AD9A",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5160",
    stopOpacity: 0.146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F3AD9A",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AD9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 69.727,
    y1: 49.956,
    x2: 128.038,
    y2: 49.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3AD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F3AD9A",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5160",
    stopOpacity: 0.146
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F3AD9A",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AD9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(459.884 0 0 649.123 344.751 -38.183)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68870"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68870"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E68870",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E68870",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E68870",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E68870",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E68870",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E68870",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E68870",
    stopOpacity: 0.088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E68870",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E68870",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68870",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(277.052 -38.34) scale(685.983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68870"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68870"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E68870",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E68870",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E68870",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E68870",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E68870",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E68870",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E68870",
    stopOpacity: 0.088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E68870",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E68870",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68870",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7b51fe059eea3e20faa7597135b06caa.svg";
export { ForwardRef as ReactComponent };